import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from '../Components/Header.tsx';
import Sidebar from '../Components/Sidebar.tsx';
import { useUserContext } from "../Context/UserContext.tsx";
import { useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { ScrollTop } from "primereact/scrolltop";
import { Toast } from "primereact/toast";
import { useNetwork } from "../Context/NetworkProvider.tsx";
import PlanSwitcher from "../Components/PlanSwitcher.tsx";


const Layout = () => {
  const { role, isUserLoaded, serviceLine, username } = useUserContext();
  const { toastRef } = useNetwork();
  const location = useLocation();

  useEffect(() => {
    // Reset scroll position whenever the route changes
    window.scrollTo(0, 0);
    
    // Reset any scrollable container as well
    const scrollableContainer = document.getElementById("scrollable-container");
    if (scrollableContainer) {
      scrollableContainer.scrollTop = 0;
    }
  }, [location.pathname]);


  useEffect(() => {
    if (!isUserLoaded) return;
  }, [role, isUserLoaded, username, serviceLine]); // Added username and serviceLine to dependencies

  if (!isUserLoaded) {
    // Add a loading spinner here
    return <div className="flex justify-content-center align-items-center h-screen"><ProgressSpinner/></div>;
  }

  return (
    <div className="dashboard">
      <Toast ref={toastRef} />
      <Header />
      <Sidebar />
      <div className="main-contain" id="scrollable-container">
        <PlanSwitcher />
        <Outlet />
        <ScrollTop />
      </div>
    </div>

  );
};
export default Layout;